import React, { Component } from 'react';
import '../styles/style.css';

export class Branch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hide: true,
            noOfMembers: 0,
            unemployedMembers: 0,
            affectedmembers: 0
        };
    }

    isAreaBranch(type) {
        if (type === 'areabranch') {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.noOfMembers !== prevState.noOfMembers) {
            if (this.props.parentCallback) {
                this.props.parentCallback('noofmembers:' + this.state.noOfMembers);
            }
        }

        if (this.state.affectedmembers !== prevState.affectedmembers) {
            if (this.props.parentCallback) {
                this.props.parentCallback('noofaffected:' + this.state.affectedmembers);
            }
        }

        if (this.state.unemployedMembers !== prevState.unemployedMembers) {
            if (this.props.parentCallback) {
                this.props.parentCallback('noofunemployed:' + this.state.unemployedMembers);
            }
        }
    }

    componentDidMount() {
        this.getDataForBranch();
    }

    getDataForBranch() {
        let period = this.props.period;
        if (period !== null) {
            period = period.split(":");
            let periodYear = period[0];
            let periodMonth = period[1];

            let baseUrl = window.location.origin;

            var fetchStr = baseUrl + '/api/statistic/department?type=branch&departmentName={name}&year={year}&month={month}'.replace('{name}', this.props.branchname).replace('{year}', periodYear).replace('{month}', periodMonth);
            fetch(fetchStr).then(res => res.json()).then(
                (result) => {
                    this.setState({
                        noOfMembers: result.numberofmembers,
                        unemployedMembers: result.unemploymentnumber,
                        affectedmembers: result.affectednumber
                    });
                }
            );
        }
    }

    calculatePercentage(members, unemployed) {
        if (unemployed === "0" || members === "0") {
            return "0";
        }

        return parseFloat((((unemployed - members) / members) * 100) + 100).toFixed(2).replace(".", ",");
    }

    render() {
        const rowEven = (this.props.rowclass === 1) ? 'row-even' : 'row-uneven';

        const classes = `areabranch row ${rowEven}`;

        return (
            <div className={classes}>
                <div className='col1'>{this.props.branchname}</div>
                <div className='col2'>{this.props.description}</div>
                <div className='col3'>{this.state.noOfMembers}</div>
                <div className='col4'>{this.state.unemployedMembers}</div>
                <div className='col5'>{this.calculatePercentage(this.state.noOfMembers, this.state.unemployedMembers)}%</div>
                <div className='col6'>{this.state.affectedmembers}</div>
                <div className='col7'>{this.calculatePercentage(this.state.noOfMembers, this.state.affectedmembers)}%</div>
            </div>
        );
    }
}